import React from 'react';
import partnerBanner from '../img/envision/aboutdd/pppss.JPG';
import AboutPartnersbanner from './AboutPartnersbanner';
import Aboutpatnersectionfirst from './Aboutpatnersectionfirst';
import Aboutwithparthers from './Aboutwithparthers';
import AboutqualityBanner from './AboutqualityBanner';
import Aboutqualitysection from './Aboutqualitysection';
import Aboutusobjectives from './Aboutusobjectives';
import AboutQualityCards from './AboutQualityCards';
import AboutqualityCertificatecards from './AboutqualityCertificatecards';
import DigitaltwinBanner from './DigitaltwinBanner';
// import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Automotivemobilitecards from './Automotivemobilitecards';
import ItriskBanner from './ItriskBanner';
import Intelligentmobility from './Intelligentmobility';
const Inteligentmobilitypage = () => {
    return (
        <div style={{ backgroundColor: '#fff' }}>
            <Intelligentmobility />
           {/* <ItriskBanner /> */}
            <Automotivemobilitecards />
           <AutomobilityTabs />
           <Automobilityverticaltabs />
           <AerospaceIntroductioncards />
           <AerospaceanimatedCards />
           <AerospaceInsightsCards />
            {/* <Aboutqualitysection /> */}
            {/* <Aboutwithparthers /> */}
            {/* <Aboutusobjectives />
            <AboutQualityCards />
            <AboutqualityCertificatecards /> */}
        </div>
    );
};

export default Inteligentmobilitypage;
